'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _iBemReact = require('@yandex-lego/i-bem-react');

exports.default = (0, _iBemReact.declMod)({ glyph: '*' }, {
    block: 'icon',
    mods: function mods() {
        return _extends({}, this.__base.apply(this, arguments), { 'has-glyph': 'yes' });
    }
});